import { useState, useEffect } from "react";
import { DollarSign } from "lucide-react";
import api from "@/lib/api";

const money = (n) => `$${Math.round(n).toLocaleString()}`;

export const RevenueByPlan = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/api/admin/revenue-by-plan").then(r => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const max = Math.max(1, ...d.plans.map(p => p.mrr));
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm mb-6" data-testid="revenue-by-plan">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-4">
        <div><p className="text-xs uppercase tracking-wider text-slate-500 flex items-center gap-1"><DollarSign className="w-3.5 h-3.5" />Monthly recurring revenue</p>
          <p className="text-3xl font-black text-slate-900" data-testid="mrr-total">{money(d.total_mrr)}<span className="text-sm font-medium text-slate-400">/month</span></p></div>
        <p className="text-sm text-slate-500" data-testid="mrr-counts">{d.total_subscribers} paying subscribers{d.total_trials ? ` · ${d.total_trials} on free trial` : ""}</p>
      </div>
      <div className="space-y-3">
        {d.plans.map(p => (
          <div key={p.plan_id} data-testid={`mrr-plan-${p.name.toLowerCase()}`}>
            <div className="flex justify-between text-sm mb-1"><span className="font-semibold text-slate-800">{p.name} <span className="text-slate-400 font-normal">· ${p.price}/mo · {p.subscribers} subscribers{p.trials ? ` · ${p.trials} trials` : ""}</span></span><span className="font-bold text-slate-900">{money(p.mrr)}</span></div>
            <div className="h-2.5 bg-slate-100 rounded-full overflow-hidden"><div className="h-full bg-blue-600 rounded-full transition-[width] duration-700" style={{ width: `${(p.mrr / max) * 100}%` }} /></div>
          </div>
        ))}
      </div>
    </div>
  );
};
